function EmptyIcon(props) {
    return <div style={{ height: '16px', width: '16px' }} />;
}

export default EmptyIcon;
